import { createSelector } from "reselect";

const selectEvents = state => state.get("events");
const makeSelectEventsList = createSelector(
  selectEvents,
  substate => substate.get("eventsList").toJS()
);

export { makeSelectEventsList };
